<template>
  <div>
    <!-- for zoom image -->
    <div v-if="zoomImg">
      <zoomImage
        :signedUrl="signedUrl"
        :src="src"
        :classes="classes"
        :styles="styles"
        :urlReceiveFlag="urlReceiveFlag"
        :newSrcImage="newSrcImage"
      ></zoomImage>
    </div>

    <!-- for normal image -->
    <div v-else>
      <img
        :src="signedUrl"
        :alt="src"
        :class="classes"
        class="image-responsive"
        :style="styles"
        v-if="urlReceiveFlag"
      />
      <img
        :class="classes"
        class="image-responsive"
        :src="newSrcImage"
        :alt="src"
        :style="styles"
        v-else
      />
    </div>
  </div>
</template>

<script>
const zoomImage = () => import("@/components/zoomImage.vue");
import config from "@/config.js";
export default {
  components: {
    zoomImage,
  },
  props: ["src", "styles", "classes", "zoomImg"],
  data: function () {
    return {
      signedUrl: "",
      urlReceiveFlag: false,
      newSrcImage: "",
    };
  },
  watch: {
    src: {
      handler(newValue) {
        if (newValue) {
          this.checkSrc();
        }
      },
    },
  },
  mounted() {
    this.checkSrc();
  },
  methods: {
    checkSrc() {
      if (this.src != "" && this.src.includes("amazonaws.com")) {
        this.urlReceiveFlag = true;
        this.loadImage();
      } else if (this.src.includes("blob")) {
        this.urlReceiveFlag = false;
        this.newSrcImage = this.src;
      } else {
        this.urlReceiveFlag = false;
        this.newSrcImage = this.src;
      }
    },
    loadImage() {
      this.$http
        .get(`${config.BASE_URL}api/v2/signed-resource?s3Url=${this.src}`)
        .then((response) => {
          this.signedUrl = response.data.signedUrl;
        })
        .catch(console.log);
      // this.signedUrl = response.signedUrl;
    },
  },
};
</script>

<style>
</style>





